export const initialValues = {
  reg: 'us',
  srv: [] as string[],
  sourceDomain: '',

  /* General Information */
  genComp: '',
  genAddr: '',
  genDirName: '',
  genDirEmail: '',
  genDirAddr: '',
  genTaxID: '',
  genDesc: '',
  genPrice: '',
  genUrl: '',
  genFullName: '',
  genEmail: '',
  genSkype: '',
  genPhone: '',
  genRefSource: '',

  /* Credit Card Processing */
  ccpFulfill: 'no',
  ccpCallCtr: 'no',
  ccpLic: 'no',
  ccpLicJur: '',
  ccpBankAcq: '',
  ccpCurrMCC: '',
  ccpAvgTxVal: '',
  ccpCurrMonthVol: '',
  ccpExpMonthVol: '',
  ccpDescLine1: '',
  ccpDescLine2: '',
  ccpPrefGateway: '',
  ccpProcCurr: '',
  ccpSettleCurr: '',
  ccpTargetMarkets: '',

  /* Card Issuing / Affiliate Payouts */
  apRegNum: '',
  apUsage: '',
  apProjVolume: '',
  apProjCount: '',
  apAvgTxValue: '',
  apCardCount: '',
  apCurrencies: '',
  apProduct: [],

  /* Whitelabel Gateway */
  wlExpMonthVol: '',
  wlExpTxCount: '',
  wlAvgTxVal: '',
  wlLicense: 'no',
  wlLicJur: '',
  wlGatewayFeatures: [],
  wlOtherGateway: '',
  wlTargetMarkets: '',
  wlBankAcquirers: '',
  wlAltBilling: '',
  wlOtherRemarks: '',

  /* ACH */
  chPayee: '',
  chClient: '',
  chCustEmail: '',
  chMktDesc: '',
  chCompHandling: '',
  chRefundPol: 'no',
  chAchProvider: '',
  chAchName: '',
  chAchPhone: '',
  chAchEmail: '',
  chHighTxAmt: '',
  chAvgTxAmt: '',
  chMaxTxPerDay: '',
  chReqMonthLimit: '',
  chRecTxPerc: '',
  chRefundCap: 'no',
  chAchCreditCap: 'no',

  /* Corporate Banking */
  cbBusinessAddr: '',
  cbPEP: '',
  cbMainClients: '',
  cbFromCountry: '',
  cbCurrency: '',
  cbMonthlyVol: '',
  cbNumPayments: '',
  cbIncomingFunds: '',
  cbToCountry: '',
  cbOutgoingFunds: '',

  /* Incorporation */
  incSuggestedName: '',
  incOfficeInUSA: '',
  incCurrentMerchantName: '',
  incExistingAddress: '',
  incCompanyDescription: '',
  incMonthlyVolume: '',
  incAvgTransactionValue: '',
  incBillingDescriptor1: '',
  incCityField: '',
  incBOName1: '',
  incBONationality1: '',
  incBOAddress1: '',
  incBOShares1: '',
  incBOName2: '',
  incBONationality2: '',
  incBOAddress2: '',
  incBOShares2: '',
  incDirectorName1: '',
  incDirectorNationality1: '',
  incDirectorName2: '',
  incDirectorNationality2: '',

  /* Alternative Billing */
  abProduct: [],
  abProjectedVolume: '',
  abProjectedTxCount: '',
  abLowestTxAmount: '',
  abHighestTxAmount: '',
  abAvgTxAmount: '',
  abTargetMarkets: '',
  abSalesTurnover: '',
};
